import { useAuth } from "../../../../hooks/AuthenticateContext";
import React, { useCallback, useRef, useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import Grid from "../../../../components/Grid";
import { usePaykit } from "../../../../hooks/PaykitContext";

import Loading from "../../../../core/common/Loading";
import {
  formatDateTimeBR,
  getCargoTypes,
  getOperationTypesPorto,
  maskCnpj,
  renderCargoTypes,
} from "../../../../helpers/format";
import { STATUS_OPERACOES_PATIO_TRIAGEM } from "../../../../helpers/status";
import { useModal } from "../../../../hooks/ModalContext";
import { useStatus } from "../../../../hooks/StatusContext";
import api from "../../../../services/api";
import { FrontendNotification } from "../../../../shared/Notification";
import Info from "./Info";
import { RowSelection } from "../../../../components/Grid/model/Grid";



const Triagens = () => {
  const { user } = useAuth();
  const [columns] = useState([
    {
      headerName: "Data de Entrada",
      field: "entrada_veiculo.data_hora",
      fieldName: "data_hora",
      filter: true,
      sort: "desc",
      filterParams: {
        dateBetween: true,
      },
      type: "dateColumn",
      valueFormatter: (params) => {
        if (params.value) {
          return formatDateTimeBR(params.value);
        }

        return "---";
      },
    },
    {
      headerName: "Placa Dianteira",
      field: "entrada_veiculo.placa_dianteira",
      fieldName: "placa",
      filter: true,
      valueFormatter: (params) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      headerName: "Identificadores dos Contêineres",
      field: "operacao_porto_agendada.identificadores_conteineres",
      fieldName: "identificadores_conteineres",
      filter: true,
      valueFormatter: (params) => {
        if (params.value) {
          return params.value.replace("{", "").replace("}", "");
        }
        return "---";
      },
    },
    {
      headerName: "Chamada Motorista",
      field: "chamada_motorista",
      fieldName: "chamada_motorista",
      filter: true,
      type: "booleanColumn",
      filterParams: {
        selected: {
          isMultiple: false,
          data: [
            { value: true, label: "SIM" },
            { value: false, label: "NÃO" },
          ],
        },
      },
      valueFormatter: (params) => {
        if (params.value) {
          return "SIM";
        }
        return "NÃO";
      },
    },
    {
      headerName: "Tipo de Operação no Porto",
      field: "operacao_porto_agendada.tipo_carga",
      fieldName: "tipo_operacao_porto",
      filter: true,
      filterParams: {
        selected: {
          isMultiple: false,
          data: getOperationTypesPorto(),
        },
      },
      valueFormatter: (params) => {
        if (params.data) {
          if (params.data.id_operacao_porto_agendada !== null) {
            return "TRIAGEM";
          } else if (params.data.id_operacao_porto_carrossel !== null) {
            return "CARROSSEL";
          } else {
            return "ESTADIA";
          }
        }
        return "---";
      },
    },
    {
      headerName: "Tipo de Agendamento",
      field: "operacao_porto_agendada.tipo_carga",
      fieldName: "tipo_carga",
      filter: true,
      filterParams: {
        selected: {
          isMultiple: false,
          data: getCargoTypes(),
        },
      },
      valueFormatter: (params) => {
        if (params.value) {
          return renderCargoTypes(params.value).replaceAll(",", "");
        }
        return "---";
      },
    },
    {
      headerName: "Nome do Motorista",
      field: "motorista.nome",
      filter: true,
      fieldName: "cpf_motorista",
      valueFormatter: (params) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      headerName: "Terminal",
      field: "operacao_porto_agendada.terminal.razao_social",
      fieldName: "terminal",
      filter: true,
      valueGetter: (params) => {
        return (
          params.data?.operacao_porto_agendada?.terminal?.razao_social ||
          params.data?.operacao_porto_carrossel?.terminal?.razao_social
        );
      },
      valueFormatter: (params) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      headerName: "Proprietario de Carga",
      field: "operacao_porto_carrossel.proprietarioDeCarga.razao_social",
      fieldName: "proprietario_carga",
      filter: true,
      valueFormatter: (params) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      headerName: "Transportadora",
      field: "operacao_porto_agendada.transportadora.razao_social",
      fieldName: "transportadora",
      filter: true,
      valueFormatter: (params) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      headerName: "CNPJ da Transportadora",
      field: "operacao_porto_agendada.transportadora.cnpj",
      fieldName: "cnpj_transportadora",
      filter: true,
      valueFormatter: (params) => {
        if (params.value) {
          return maskCnpj(params.value);
        }
        return "---";
      },
    },
    {
      headerName: "Data de Saída",
      field: "entrada_veiculo.saida.data_hora",
      fieldName: "data_hora_saida",
      filter: true,
      filterParams: {
        dateBetween: true,
      },
      type: "dateColumn",
      valueFormatter: (params) => {
        if (params.value) {
          return formatDateTimeBR(params.value);
        }
        return "---";
      },
    },
    {
      field: "usuario",
      headerName: "Usuário",
      filter: true,
      valueFormatter: (params) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
  ]);
  const [isRemove, setIsRemove] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [isView, setIsView] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showTicket, setShowTicket] = useState(false);

  const DEFAULT_FILTERS = {
    "id_transportadora": user?.id_transportadora
  };

  const gridRef = useRef();
  const authenticatedRef = useRef(false);

  const { authenticated, error, authenticate, reprint } = usePaykit();


  const { openModal, isModalOpen, closeModal } = useModal();

  const { setStatus } = useStatus();

  const getCallDriver = useCallback(async (data) => {
    try {
      setLoading(true);

      const body = {
        id_operacao_patio: data.id_operacao_patio,
        boolean_chamada: !data.chamada_motorista,
      };

      await api.post("/operacaopatio/chamadaMotorista", body);

      setSelectedRow(data);

      FrontendNotification(
        "Chamada do motorista realizada com sucesso!",
        "success"
      );

      gridRef.current?.refresh();

      setLoading(false);
    } catch {
      setLoading(false);
    }
  }, []);

  const onDelete = useCallback(async (rowId, data) => {
    try {
      setLoading(true);

      if (data && data.status > 0) {
        const body = {
          id_operacao_patio: rowId,
        };

        await api.post("/deletar/desassociarTriagem", body);

        setLoading(false);

        setIsRemove(false);

        gridRef.current?.refresh();
      } else {
        const body = {
          id_operacao_patio: rowId,
        };

        await api.post("/deletar/operacaoPatio", body);

        setLoading(false);

        setIsRemove(false);

        gridRef.current?.refresh();
      }
    } catch {
      setLoading(false);
    }
  }, []);

  var onPaymentSuccess = function (response) {
    console.log("Payment operation successful:", response);




    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;


    const printWindow = window.open('', '', `width=${screenWidth},height=${screenHeight},top=0,left=0`);
    printWindow.document.write(`<!DOCTYPE html>
    <html lang="pt-BR">
      <head>
        <meta charset="UTF-8">
        <title></title> <!-- Deixe o título vazio -->
        <style>
          body {
            font-family: monospace;
            white-space: pre;
            font-size: 14px;
            margin: 0;
            padding: 20px;
          }

          @media print {
            @page {
              margin: 0;
            }
            body {
              margin: 0;
              padding: 2px;
            }
          }
        </style>
      </head>
      <body>
        <pre>${response.receipt.merchantReceipt}</pre>
      </body>
    </html>`);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();

    // setContentTicket(response.receipt.merchantReceipt);

    setShowTicket(false);
    setShowTicket(true);


  };

  var onPaymentError = function (error) {
    console.error("Payment operation error:", error);
    console.log('Code: ' + error.reasonCode + ' - ' + error.reason);

    let errorMessage = error.reason || "Payment operation failed";

    if (error.reasonCode == 9) {
      if (window.PaykitCheckout && authenticated) {
        try {
          const result = window.PaykitCheckout.undoPayments();
          console.log("Payments undone:", result);
          errorMessage = "Transaction cancelled and payments undone";
        } catch (err) {
          console.error("Error undoing payments:", err);
          errorMessage = "Transaction cancelled but failed to undo payments";
        }
      }
    }

    FrontendNotification(errorMessage, "error");
  };





  const reprintPayment = useCallback(async (data, isAuthenticate) => {
    try {

      const body = {
        id_operacao_patio: Number(data.id_operacao_patio),
        qtd_por_pagina: 100,
        order_by: "data_historico",
        order_direction: "desc",
      };

      const response = await api.post(
        `/operacaopatio/pagamentos?page=1`,
        body
      );

      const responseData = response.data.data.sort((a, b) => a.id_operacao_patio_pagamento - b.id_operacao_patio_pagamento);
      console.log(responseData)

      console.log(responseData);
      console.log(isAuthenticate)

      if (responseData.length > 0) {
        const lastPayment = responseData[responseData.length - 1];
        if (lastPayment.administrative_code !== null) {
          const request = {
            administrativeCode: lastPayment.administrative_code,
          };

          // Use the Paykit SDK directly for reprint since it's not in the new hook yet
          try {
            console.log("entrou")
            reprint(
              request,
              (response) => {
                console.log("Reprint successful:", response);
                onPaymentSuccess(response);
              },
              (error) => {
                console.error("Reprint error:", error);
                onPaymentError(error);
              }
            );
          } catch (err) {
            console.error("Error calling reprint:", err);
            FrontendNotification("Error during reprint operation", "error");
          }

        } else {
          FrontendNotification("Reimpressão não disponivel pra essa triagem!", "warning");
        }
      }
    } catch (err) {
      console.error("Error getting payment data:", err);
      FrontendNotification("Error retrieving payment data", "error");
    }
  }, [authenticated]);





  useEffect(() => {
    console.log(authenticated);

    authenticatedRef.current = authenticated;
  }, []);

  console.log(authenticatedRef.current)


  return (
    <>
      <Loading loading={loading} />
      <ToastContainer />

      {isView && (
        <Info
          data={selectedRow}
          title="Conhecer - Triagens"
          onClose={() => setIsView(!isView)}
        />
      )}

      <div className="flex flex-col w-full h-screen bg-[#F5F5F5] p-5">
        <div className="flex items-center justify-between w-full mb-3">
          <div>
            <h1 className="text-2xl text-[#000000] font-bold">Triagens</h1>
          </div>
        </div>
        <div className="flex w-[calc(100vh - 90px)]">
          <Grid
            ref={gridRef}
            columns={columns}
            filters={[]}
            pagination
            customFilters={DEFAULT_FILTERS}
            rowSelection={RowSelection.MULTIPLE}
            path="/listar/operacaoPatioTriagem"
            persistFiltersKey="triagens_filters"
            onDelete={(data) => {
              setIsRemove(!isRemove);
              setSelectedRow(data);
            }}
            isShowStatus
            status={STATUS_OPERACOES_PATIO_TRIAGEM}
            getStatusData={(data, statuses) => {
              if (Number(data?.status) === 6 && data?.saida_combustivel) {
                return {
                  ...(statuses.find((item) => item.id === 6) || {}),
                  id: 6,
                  label: "Associado - Saída Combustível",
                };
              }

              return undefined;
            }}
            onView={(data) => {
              setSelectedRow(data);
              setIsView(!isView);
            }}
            onUpdate={(data) => {
              setSelectedRow(data);
              setIsEdit(!isEdit);
              openModal();
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Triagens;